import { Controller } from "@hotwired/stimulus"
import { OPEN_REQUEST_EVENT, PRELOAD_REQUEST_EVENT, TOGGLE_REQUEST_EVENT } from "./global_sidebar_controller"

export default class extends Controller {
  open() {
    this._request(OPEN_REQUEST_EVENT)
  }

  toggle() {
    this._request(TOGGLE_REQUEST_EVENT)
  }

  preload() {
    this._request(PRELOAD_REQUEST_EVENT)
  }

  _request(eventName) {
    document.dispatchEvent(new CustomEvent(eventName))
  }
}
